import { render } from "./alertComponent.vue?vue&type=template&id=2f26b752&scoped=true"
import script from "./alertComponent.vue?vue&type=script&lang=js"
export * from "./alertComponent.vue?vue&type=script&lang=js"

import "./alertComponent.vue?vue&type=style&index=0&id=2f26b752&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f26b752"]])

export default __exports__